import {
  GOOGLE_DRIVE_API,
  GOOGLE_DRIVE_CONFIG,
  setDriveTokenInfo,
} from './drives.constants';
import axios from 'axios';
import { baseUrlApis, FROM_TYPE } from 'Api/index';
import { store } from 'Store/index';
import {
  getFileSize, /* handlerFileNameWithoutExtension,  */
  getQueryVariable, storageGetItem, storageRemoveItem,
  storageSetItem, windowActionFn,
} from 'Utils/utils';
import intl from 'react-intl-universal';
import { updateProp } from 'Utils/utils';
import { MessageUtil } from 'Api/utils/Message.util';


export default class CommonDriveApi {
  constructor() {
    this.gapi = null;
    this.fnMap = {};
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.updateFileRequest = false;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;
    this.cancelUpdateFileFn = null;
    this.googleDriveAxios = null;
    this.commonDriveAxios = null;
    this.CancelToken = axios.CancelToken;
    this.targetOrigin = `${window.location.origin}`;
    this.onRequestCallback = this.onRequestCallback.bind(this);


    this.init();
  }

  onRequestCallback(method, data, id) {
    return new Promise((resolve) => {
      const fn = this.fnMap[method];
      fn && fn({ method, data, id, resolve });
    });
  }
  formatUserInfo(userInfo){
    if (Object.keys(userInfo).length != 0){
      return {
        "userId": userInfo.userId.substring(11),
        "title": userInfo.title
      };
    }
    return userInfo;

  }

  init() {
    this.commonDriveAxios = axios.create({
      baseURL: GOOGLE_DRIVE_API.BASEURL,
    });
    this.commonDriveAxios.interceptors.request.use((config) => {
      config.baseURL = 'http://www.baidu.com';
    });
    // console.log(this.commonDriveAxios.baseURL)
    // function onHandleWindowMessage(event){
    //
    //   console.log(event)
    // }
    this.windowMessageUtil = new MessageUtil(true);
    this.windowMessageUtil.init(this.onRequestCallback, FROM_TYPE.ONLINE, this.targetOrigin);
    //
    // function onHandleWindowMessage(event){
    //
    //   console.log(event)
    // }
    // window.addEventListener('message', onHandleWindowMessage, false);

    // this.googleDriveAxios = axios.create({
    //   baseURL: GOOGLE_DRIVE_API.BASEURL,
    // });

    // this.commonDriveAxios.interceptors.request.use(
    //   (config) => {
    //     store.driveStore.numberOfAjaxCAllPendingIncrease();
    //
    //     let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');
    //
    //     if (accessToken) {
    //       config.headers = {
    //         Authorization: `Bearer ${accessToken}`,
    //         ...config.headers,
    //       };
    //     }
    //
    //     if (!store.driveStore.loading) {
    //       store.driveStore.setLoadingState(true);
    //     }
    //
    //     return config;
    //   },
    //   (error) => {
    //     return Promise.reject(error);
    //   },
    // );
    // this.googleDriveAxios.interceptors.response.use(
    //   (res) => {
    //     store.driveStore.numberOfAjaxCAllPendingDecrease();
    //
    //     return res.data;
    //   },
    //   (error) => {
    //     store.driveStore.numberOfAjaxCAllPendingDecrease();
    //
    //     this.errorHandler(error);
    //
    //     return Promise.reject(error);
    //
    //   },
    // );
    // GOOGLE_DRIVE_CONFIG.SET_APP_CONFIG()
  }

  getOAuthToken() {
    var user = this.gapi.auth2.getAuthInstance().currentUser.get();

    return user.getAuthResponse().access_token;
  }

  errorHandler(error) {
    let errorMsg;
    let status = error.status || (error.response && error.response.status);

    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else if (status === 403) {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'InvalidToken' });
    } else if (error && error.message.indexOf('401') > -1) {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'DrivesListDlg.TokenExpire' });
    } else if (error.message === 'Network Error') {
      errorMsg = intl.formatMessage({ id: 'NetworkError' });
    } else {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'Error.SignOutAndRetry' });
    }

    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }

  signOut(driveName,success) {
    console.log('notify: 4. signOut');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    pdfui.pdfViewer.eventEmitter.emit('onDriverSignOut', {
      'driverId': driverId,
      userInfo
    });
    // let driverTitle = store.netDriverStore.findDriverTitle(driveName);
    storageRemoveItem(localStorage, `ext_driver_${driveName}`);
    success && success();
  }

  downloadFile(driveName, item, success, fail) {
    console.log('notify: 4. onDriveDownloadFile');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    this.downloadFileRequest = true;

    pdfui.pdfViewer.eventEmitter.emit('onDriveDownloadFile', {
      'driverId': driverId,
      'item': item,
      userInfo
    });

    let _this = this;

    function onHandleWindowMessage(event) {
      let data = null;
      let method = null;
      let url = null;
      let headers = null;
      if (event.data.driverId &&
          event.data.driverId == driverId &&
          event.data.eventName &&
          event.data.eventName === 'onDriverDownloadFile') {
        headers = event.data.headers;
        data = event.data.data;
        method = event.data.method;
        url = event.data.url;


        window.removeEventListener('message', onHandleWindowMessage);
        // event.data.user.id = res.user.permissionId
        _this.commonDriveAxios = axios.create({
          baseURL: 'GOOGLE_DRIVE_API.BASEURL',
        });

        _this.commonDriveAxios.interceptors.request.use(
          (config) => {
            store.driveStore.numberOfAjaxCAllPendingIncrease();

            config.headers = {
              // Authorization: `Bearer ${accessToken}`,
              ...headers,
            };

            // let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');
            //
            // if (accessToken) {
            //   config.headers = {
            //     Authorization: `Bearer ${accessToken}`,
            //     ...config.headers,
            //   };
            // }

            if (!store.driveStore.loading) {
              store.driveStore.setLoadingState(true);
            }

            return config;
          },
          (error) => {
            return Promise.reject(error);
          },
        );

        _this.commonDriveAxios.interceptors.response.use(
          (res) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            return res.data;
          },
          (error) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            this.errorHandler(error);

            return Promise.reject(error);
          },
        );
        //   GOOGLE_DRIVE_CONFIG.SET_APP_CONFIG();
        // },

        if (method == 'GET') {
          _this.commonDriveAxios({
            url: url,
            method: method,
            params: data,
            responseType: 'blob',
            cancelToken: new _this.CancelToken((c) => {
              _this.cancelDownloadFileFn = c;
            }),
          }).then((res) => {
            _this.downloadFileRequest = false;
            success && success({ blob: res, id: item.id, fileName: item.name });
          }).catch((error) => {
            _this.downloadFileRequest = false;
            fail && fail(error.response);
          });

        } else {
          if (JSON.stringify(data) == '{}') {
            _this.commonDriveAxios({
              url: url,
              method: method,
              responseType: 'blob',
              cancelToken: new _this.CancelToken((c) => {
                _this.cancelDownloadFileFn = c;
              }),
            }).then((res) => {
              _this.downloadFileRequest = false;
              success && success({ blob: res, id: item.id, fileName: item.name });
            }).catch((error) => {
              _this.downloadFileRequest = false;
              fail && fail(error.response);
            });
          } else {
            _this.commonDriveAxios({
              url: url,
              method: method,
              data: data,
              responseType: 'blob',
              cancelToken: new _this.CancelToken((c) => {
                _this.cancelDownloadFileFn = c;
              }),
            }).then((res) => {
              _this.downloadFileRequest = false;
              success && success({ blob: res, id: item.id, fileName: item.name });
            }).catch((error) => {
              _this.downloadFileRequest = false;
              fail && fail(error.response);
            });
          }

        }


      }


    }


    window.addEventListener('message', onHandleWindowMessage, false);


    // if (GOOGLE_EXCLUSIVE_MIME_TYPE.indexOf(item.mimeType) > -1 ) {
    //   this.googleDriveAxios({
    //     url: `${GOOGLE_DRIVE_API.EXPORT_FILE}/${item.id}/export`,
    //     method: 'GET',
    //     params: {
    //       fields: '*',
    //       mimeType: 'application/pdf',
    //       alt: 'media',
    //     },
    //     responseType: 'blob',
    //     cancelToken: new this.CancelToken((c) => {
    //       // An executor function receives a cancel function as a parameter
    //       this.cancelDownloadFileFn = c;
    //     }),
    //   }).then((res) => {
    //     this.downloadFileRequest = false;
    //
    //     success && success({ blob: res, id: item.id, fileName: item.name });
    //   })
    //     .catch((error) => {
    //       this.downloadFileRequest = false;
    //
    //       fail && fail(error.response);
    //     });
    //
    //   return
    // }
    //
    // this.googleDriveAxios({
    //   url: `${GOOGLE_DRIVE_API.DOWNLOAD_FILE}/${item.id}`,
    //   method: 'GET',
    //   params: {
    //     fields: '*',
    //     key: GOOGLE_DRIVE_CONFIG.API_KEY,
    //     alt: 'media',
    //   },
    //   responseType: 'blob',
    //   cancelToken: new this.CancelToken((c) => {
    //     // An executor function receives a cancel function as a parameter
    //     this.cancelDownloadFileFn = c;
    //   }),
    // })
    //   .then((res) => {
    //     this.downloadFileRequest = false;
    //
    //     success && success({ blob: res, id: item.id, fileName: item.name });
    //   })
    //   .catch((error) => {
    //     this.downloadFileRequest = false;
    //
    //     fail && fail(error.response);
    //   });
  }

  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }

  getUserInfo(driveName, success, fail) {
    console.log('notify: 2. onDriverGetUserInfo');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    pdfui.pdfViewer.eventEmitter.emit('onDriverGetUserInfo', {
      "driverId":driverId,
      userInfo
    });
    console.log('notify:2. 2 onDriverGetUserInfo end')
    // console.log(fail);

    function onHandleWindowMessage(event) {

      if (event.data.driverId &&
          event.data.driverId == driverId &&
          event.data.eventName &&
          event.data.eventName === 'onDriverSetUserInfo') {
        let accessToken = storageGetItem(localStorage, driveName);
        window.removeEventListener('message', onHandleWindowMessage);
        // event.data.user.id = res.user.permissionId
        let user = {};

        if (event.data.userAccount != null && event.data.userAccount !== '') {
          user.userAccount = event.data.userAccount;
          user.accessToken = accessToken;

          let userInfo = {
            "userId":event.data.userAccount,
            "title":event.data.title
          };
          storageSetItem(localStorage, `ext_driver_${driveName}`, JSON.stringify(userInfo));

          store.netDriverStore.SetDriverUserInfo(
              driveName,
              userInfo
          );
          setDriveTokenInfo(driveName, event.data.userAccount);
          success && success(event.data);
        } else {
          if(event.data.error && event.data.error.errorMsg != ""){
            store.appStore.setGlobalMessage({ type: 'error', content:  event.data.error.errorMsg });
            event.data.error.autoSignOut = true
          }

          store.driveStore.onResetAjaxCAllPending()
          store.driveStore.onNumberOfAjaxCAllPendingIncrease()
          fail && fail(event.data.error);
        }
      }
    }

    window.addEventListener('message', onHandleWindowMessage, false);
  }

  createFile(driveName, file, folderPath, success, fail) {
    console.log('notify: onDriverUploadFile');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    pdfui.pdfViewer.eventEmitter.emit('onDriverUploadFile', {
      'driverId': driverId,
      'name': file.name,
      'folderPath': folderPath,
      'blob':file,
      userInfo
    });

    let _this = this;

    function onHandleWindowMessage(event) {
      if (event.data.driverId &&
          event.data.driverId == driverId &&
          event.data.eventName &&
          event.data.eventName === 'onDriverUploadFileResult') {
        window.removeEventListener('message', onHandleWindowMessage);
        _this.uploadFileRequest = false;
        if (event.data.result) {
          success && success();
        } else {
          fail && fail(event.data.error);
        }
      }
    }

    window.addEventListener('message', onHandleWindowMessage, false);


  }

  // eslint-disable-next-line no-unused-vars
  getItems(driveName, folderId, success, fail) {
    console.log('notify: 3. onDriverGetFileList');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    //storageSetItem(localStorage, `ext_driver_${driveName}`, JSON.stringify(userInfo));
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    let reload = store.netDriverStore.GetDriverReloadFlag(driveName);
    pdfui.pdfViewer.eventEmitter.emit('onDriverGetFileList', {
      driverId: driverId,
      folderId: folderId,
      userInfo,
      reload: reload
    });
    store.netDriverStore.SetDriverReloadFlag(driveName,false)

    function onHandleWindowMessage(event) {
      // console.log(fail);


      if (event.data.driverId &&
          event.data.driverId == driverId &&
          event.data.eventName &&
          event.data.eventName == 'onDriverSetFileList') {
        let folders = [];
        let files = [];
        window.removeEventListener('message', onHandleWindowMessage);
        if(event.data.error && event.data.error.errorMsg != ""){
          fail && fail(event.data.error);
        }
        else{
          let res = {};
          event.data.fileList.forEach((item) => {
            if (item.isFolder == true) {
              folders.push(item);
            } else {
              item.size = item.size && getFileSize(item.size) || '0KB';
              files.push(item);
            }

          });

          res.result = {};
          res.result.files = [...folders, ...files];

          success && success(res);
        }

        // event.data.files.forEach((item)=>{
        //
        // })
        // success()
      }

    }

    window.addEventListener('message', onHandleWindowMessage, false);

    // this.googleDriveAxios({
    //   url: GOOGLE_DRIVE_API.GET_FILES,
    //   method: 'GET',
    //   params: {
    //     // 不显示删除的文件
    //     fields: 'nextPageToken, files(id, name, size, createdTime, mimeType, modifiedTime)',
    //     q: folderId ? `'${folderId}' in parents and trashed = false` : "'root' in parents and trashed = false",
    //     pageSize: 1000,
    //     orderBy: 'name',
    //   },
    // })
    //   .then((res) => {
    //     let folders = [];
    //     let files = [];
    //     debugger
    //
    //     res.files.forEach((item) => {
    //       if (item.mimeType === 'application/vnd.google-apps.folder') {
    //         item.isFolder = true;
    //         item.size = ''
    //         item.modifiedTime = ''
    //         folders.push(item);
    //       }
    //       if (/* SUPPORT_FILE_EXTENSIONS.indexOf(item.name.replace(/.+\./,""))  > -1 */ SUPPORT_FILE_MIME_TYPES.indexOf(item.mimeType) > -1){
    //         // item.name = getFileNameWithExtension(item.name, item.mimeType)
    //         // if (GOOGLE_EXCLUSIVE_MIME_TYPE.indexOf(item.mimeType) > -1) {
    //         //   item.name = `${item.name}.pdf`
    //         // }
    //         item.originSize = item.size || '0KB'
    //         item.size = item.size && getFileSize(item.size) || '0KB'
    //         item.modifiedTime = convertUTCToLocale(item.modifiedTime);
    //         files.push(item);
    //       }
    //     });
    //
    //     res.result = {};
    //     res.result.files = [...folders, ...files];
    //
    //     success && success(res);
    //   })
    //   .catch((error) => {
    //     fail && fail(error);
    //   });
  }

  getAccessToken(code, success, fail) {
    let fd = new FormData();

    fd.append('code', decodeURIComponent(code));
    fd.append('grant_type', 'authorization_code');
    fd.append('client_id', GOOGLE_DRIVE_CONFIG.CLIENT_ID);
    fd.append('client_secret', GOOGLE_DRIVE_CONFIG.CLIENT_SECRET);
    fd.append('redirect_uri', `${baseUrlApis.getBaseUrl()}GoogleDriveAuthrizationWin.html`);
    this.googleDriveAxios({
      url: GOOGLE_DRIVE_API.GET_ACCESS_TOKEN,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: fd,
    })
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }

  redirectToGoogleOAuth(fileParams) {
    updateProp(location, 'href', `${GOOGLE_DRIVE_CONFIG.AUTHORIZATION_URL(fileParams)}`);
  }

  signInForGSuite(success) {
    const fileParams = getQueryVariable('state');
    const googleOAuthCode = getQueryVariable('googleOAuthCode');

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'GoogleDriveAccessToken', token);
      success && success();
    }

    if (fileParams && googleOAuthCode) {
      this.getAccessToken(googleOAuthCode, (res) => {
        onSignSuccess(res.access_token);
      });
    }
  }

  getAuthCode(driverId,url,success,closeWin,fail){
    //console.log(fail)
    return new Promise((resolve,reject)=>{
      // let _this = this
      let left = window.innerWidth / 2 - 300;
      let _hTime = null;
      // url = 'https://accounts.google.com/o/oauth2/v2/auth?prompt=select_account&response_type=code&client_id=780971451088-32c31q277g9p3f9ek8ejun3iml2vu8cp.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/drive&hl=en-US&redirect_uri=http://localhost:3000/DriveAuthrizationWin.html'
      // let url1=GOOGLE_DRIVE_CONFIG.AUTHORIZATION_URL()
      let _hWin = windowActionFn(window, 'open', [url, 'auth', `width=600, height=645, left=${left}, top=240`]);


      function onSignSuccess(token) {
        storageSetItem(localStorage, 'GoogleDriveAccessToken', token); //"null"
        success && success();
      }
      const msgHandler = async (event) => {

        if (event.data.driverId && event.data.driverId == driverId &&
            event.data.eventName === 'onDriverCloseAuthDialog') {
          if (event.data.error && event.data.error.errorMsg != "") {
            // 如果传过来是错误数据,那么不授权.
            fail && fail(event.data.error)
            reject(new Error('login failed'));
            return
          } else {
            console.log('recive onDriverCloseAuthDialog ok. close.')
            await clean();
            console.log('recive onDriverCloseAuthDialog ok. close. end')
            success && success()
            resolve('ok');
            return
          }
        }


        // 数据转发给插件,由插件处理.
        let origin = baseUrlApis.getBaseUrl();
        if(`${event.origin}/` === origin ){
          console.log('common_driver=>notify: 7. onAuthdata');
          let data = event.data;
          data.driverId = driverId;
          console.log('common_driver=>:'+ JSON.stringify(data));
          pdfui.pdfViewer.eventEmitter.emit('onDriverAuthData', data);
        }

      }
      const onHandleStorage = async (e) =>{
        if (e.key === 'googleDriveCode') {
          onSignSuccess(e.newValue);
          clean();
        }
      }
      const clean = async ()=>{
        if (!_hWin) {

          return;
        }
        _hWin.close();
        _hWin = null;
        closeWin && closeWin()
        _hTime && clearInterval(_hTime);
        _hTime = null;
        window.removeEventListener('message', msgHandler);
        window.removeEventListener('storage', onHandleStorage);
      }
      // start to listen
      _hTime = setInterval(() => {
        if (_hWin.closed) {

          clean();
        }
      }, 2000);

      window.addEventListener('message', msgHandler, false);
      window.addEventListener('storage', onHandleStorage, false);

    })

  }
  // eslint-disable-next-line no-unused-vars
  signIn(driveName, success, closeWin, fail) {
    console.log('notify: 1. onDriverSignIn');
    let driverId = store.netDriverStore.findDriverIdByDriverName(driveName);
    let userInfo = JSON.parse(storageGetItem(localStorage,`ext_driver_${driveName}`) || "{}");
    userInfo = this.formatUserInfo(userInfo);
    pdfui.pdfViewer.eventEmitter.emit('onDriverSignIn', {
      'driverId':driverId,
      userInfo
    });

//      const onHandleWindowMessage1=(event) =>{
//       if (event.data.driverId && event.data.driverId == driverId &&
//           event.data.eventName === 'onDriverOpenAuthDialog') {
//         // storageSetItem(localStorage, 'CommonDriverAccessToken', driveName); //"null"
//         // let driverTitle = store.netDriverStore.findDriverTitle(driveName);
//
// //////        // storageSetItem(localStorage, `ext_driver_${driveName}`, driveName); //"null"
//
//         window.removeEventListener('message', onHandleWindowMessage1);
//         //success();
//         //this.getAuthCode(driverId,event.data.url,success,closeWin,fail)
//
//
//       }

    const onHandleWindowMessage1 = (event) => {
      if (event.data.driverId && event.data.driverId == driverId &&
          event.data.eventName &&
          event.data.eventName === 'onDriverSignInResult') {

        window.removeEventListener('message', onHandleWindowMessage1);

        console.log("onDriverSignInResult")
        if(event.data.error && event.data.error.errorMsg != ""){
          fail && fail(event.data.error);
        }
        else{
          console.log("common_driver:==> onDriverSignInResult success")
          success && success()
        }
      }

    }

    window.addEventListener('message', onHandleWindowMessage1, false);
    //
    // return new Promise((resolve, reject) => {
    //   let _this = this
    //   let left = window.innerWidth / 2 - 300;
    //   let _hTime = null;
    //   let _hWin = windowActionFn(window, 'open', [GOOGLE_DRIVE_CONFIG.AUTHORIZATION_URL(), 'GoogleDriveAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);
    //
    //
    //   function onSignSuccess(token) {
    //     storageSetItem(localStorage, 'GoogleDriveAccessToken', token); //"null"
    //     success && success();
    //   }
    //   const msgHandler = async (event) => {
    //     let origin = baseUrlApis.getBaseUrl();
    //
    //     if (event.data.googleDriveCode && `${event.origin}/` === origin) {
    //       _this.getAccessToken(event.data.googleDriveCode, (res) => {
    //             clean();
    //             onSignSuccess(res.access_token);
    //           },
    //           (error) => {
    //             fail && fail(error)
    //           });
    //     }
    //   }
    //   const onHandleStorage = async (e) =>{
    //     if (e.key === 'googleDriveCode') {
    //       onSignSuccess(e.newValue);
    //       clean();
    //     }
    //   }
    //   const clean = async ()=>{
    //     if (!_hWin) {
    //
    //       return;
    //     }
    //     _hWin.close();
    //     _hWin = null;
    //     closeWin && closeWin()
    //     _hTime && clearInterval(_hTime);
    //     _hTime = null;
    //     window.removeEventListener('message', msgHandler);
    //     window.removeEventListener('storage', onHandleStorage);
    //   }
    //   // start to listen
    //   _hTime = setInterval(() => {
    //     if (_hWin.closed) {
    //
    //       clean();
    //     }
    //   }, 2000);
    //
    //   window.addEventListener('message', msgHandler, false);
    //   window.addEventListener('storage', onHandleStorage, false);
    //
    //
    // })

  }

  updateFileMultipart(fileId, file) {
    var fr = new FileReader();
    var nSize = file.size;
    var contentType = file.type || 'application/octet-stream';

    fr.onload = (evt) => {
      var boundary = '-------314159265358979323846';
      var delimiter = '\r\n--' + boundary + '\r\n';
      var close_delim = '\r\n--' + boundary + '--';
      var metadata = {
        name: file.name,
        mimeType: contentType,
        'Content-Type': contentType,
        'Content-Length': nSize,
      };
      var base64Data = evt.target.result.replace(/^data:.*;base64,/, ''); //btoa(evt.target.result);
      var multipartRequestBody =
        delimiter +
        'Content-Type: application/json\r\n\r\n' +
        JSON.stringify(metadata) +
        delimiter +
        'Content-Type: ' +
        contentType +
        '\r\n' +
        'Content-Transfer-Encoding: base64\r\n' +
        '\r\n' +
        base64Data +
        close_delim;
      var request = this.gapi.client.request({
        path: `${GOOGLE_DRIVE_API.UPDATE_FILE}/${fileId}`,
        method: 'POST',
        params: { uploadType: 'multipart' },
        headers: {
          'Content-Type': 'multipart/related; boundary="' + boundary + '"',
          'Content-Length': multipartRequestBody.length,
        },
        body: multipartRequestBody,
      });
      request.execute(
        function(/* response */) {

        },
        (error) => {
          this.errorHandler(error);
        },
      );
    };

    fr.readAsDataURL(file);
  }

  // eslint-disable-next-line no-unused-vars
  createFileMultipart(file, folderPath, success, fail, progress, mimeType, fileType) {
    console.log('notify: onDriverUploadFile');
    pdfui.pdfViewer.eventEmitter.emit('onDriverUploadFile', driveName);
    this.updateFileRequest = true;
    let headers = nil;
    let data = nil;
    let method = '';
    let url = '';
    let _this = this;

    function onHandleWindowMessage(event) {

      if (event.data.driverId && event.data.driverId == driveName) {
        headers = event.data.headers;
        data = event.data.data;
        method = event.data.method;
        url = event.data.url;

        window.removeEventListener('message', onHandleWindowMessage);
        // event.data.user.id = res.user.permissionId
        _this.commonDriveAxios = axios.create({
          baseURL: 'GOOGLE_DRIVE_API.BASEURL',
        });

        _this.commonDriveAxios.interceptors.request.use(
          (config) => {
            store.driveStore.numberOfAjaxCAllPendingIncrease();

            config.headers = {
              // Authorization: `Bearer ${accessToken}`,
              ...headers,
            };

            // let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');
            //
            // if (accessToken) {
            //   config.headers = {
            //     Authorization: `Bearer ${accessToken}`,
            //     ...config.headers,
            //   };
            // }

            if (!store.driveStore.loading) {
              store.driveStore.setLoadingState(true);
            }

            return config;
          },
          (error) => {
            return Promise.reject(error);
          },
        );

        _this.commonDriveAxios.interceptors.response.use(
          (res) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            return res.data;
          },
          (error) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            this.errorHandler(error);

            return Promise.reject(error);
          },
        );

        if (method == 'PATCH') {
          _this.commonDriveAxios({
            url: url,
            method: method,
            params: data,
            data: file,
            onUploadProgress: function(progressEvent) {
              if (progressEvent.lengthComputable) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                progress && progress(percentCompleted);
              }
            },
            cancelToken: new _this.CancelToken((c) => {
              // An executor function receives a cancel function as a parameter
              this.cancelUpdateFileFn = c;
            }),
          }).then(() => {
            this.updateFileRequest = false;

            success && success();
          })
            .catch((error) => {
              this.updateFileRequest = false;

              fail && fail(error);
            });

        }
      }
    }

    window.addEventListener('message', onHandleWindowMessage, false);
  }

  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }

  // eslint-disable-next-line no-unused-vars
  updateFileSimpleUpload(fileId, file, success, fail, progress, mimeType) {
    console.log('notify: onDriverUpdateFile');
    pdfui.pdfViewer.eventEmitter.emit('onDriverUpdateFile', driveName);
    this.updateFileRequest = true;
    let headers = nil;
    let data = nil;
    let method = '';
    let url = '';
    let _this = this;

    function onHandleWindowMessage(event) {

      if (event.data.driverId && event.data.driverId == driveName) {
        headers = event.data.headers;
        data = event.data.data;
        method = event.data.method;
        url = event.data.url;

        window.removeEventListener('message', onHandleWindowMessage);
        // event.data.user.id = res.user.permissionId
        _this.commonDriveAxios = axios.create({
          baseURL: 'GOOGLE_DRIVE_API.BASEURL',
        });

        _this.commonDriveAxios.interceptors.request.use(
          (config) => {
            store.driveStore.numberOfAjaxCAllPendingIncrease();

            config.headers = {
              // Authorization: `Bearer ${accessToken}`,
              ...headers,
            };

            // let accessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken');
            //
            // if (accessToken) {
            //   config.headers = {
            //     Authorization: `Bearer ${accessToken}`,
            //     ...config.headers,
            //   };
            // }

            if (!store.driveStore.loading) {
              store.driveStore.setLoadingState(true);
            }

            return config;
          },
          (error) => {
            return Promise.reject(error);
          },
        );

        _this.commonDriveAxios.interceptors.response.use(
          (res) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            return res.data;
          },
          (error) => {
            store.driveStore.numberOfAjaxCAllPendingDecrease();

            this.errorHandler(error);

            return Promise.reject(error);
          },
        );

        if (method == 'PATCH') {
          _this.commonDriveAxios({
            url: url,
            method: method,
            params: data,
            data: file,
            onUploadProgress: function(progressEvent) {
              if (progressEvent.lengthComputable) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                progress && progress(percentCompleted);
              }
            },
            cancelToken: new _this.CancelToken((c) => {
              // An executor function receives a cancel function as a parameter
              this.cancelUpdateFileFn = c;
            }),
          }).then(() => {
            this.updateFileRequest = false;

            success && success();
          })
            .catch((error) => {
              this.updateFileRequest = false;

              fail && fail(error);
            });

        }


      }


    }

    window.addEventListener('message', onHandleWindowMessage, false);

    // let nSize = file.size;

    // let contentType = !!mimeType?mimeType: file.type || 'application/octet-stream';
    //
    // this.updateFileRequest = true;
    // this.googleDriveAxios({
    //   url: `${GOOGLE_DRIVE_API.UPDATE_FILE}/${fileId}`,
    //   method: 'PATCH',
    //   headers: {
    //     'Content-Type': contentType,
    //     // 'Content-Length': nSize,
    //   },
    //   params: {
    //     key: GOOGLE_DRIVE_CONFIG.API_KEY,
    //     uploadType: 'media',
    //   },
    //   data: file,
    //   onUploadProgress: function (progressEvent) {
    //     if (progressEvent.lengthComputable) {
    //       var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //
    //       progress && progress(percentCompleted);
    //     }
    //   },
    //   cancelToken: new this.CancelToken((c) => {
    //     // An executor function receives a cancel function as a parameter
    //     this.cancelUpdateFileFn = c;
    //   }),
    // })
    //   .then(() => {
    //     this.updateFileRequest = false;
    //
    //     success && success();
    //   })
    //   .catch((error) => {
    //     this.updateFileRequest = false;
    //
    //     fail && fail(error);
    //   });
  }

  cancelUpdatedFile() {
    this.cancelUpdateFileFn && this.cancelUpdateFileFn();
  }

  isSignIn(driveName) {

    let driverTitle = store.netDriverStore.findDriverTitle(`ext_driver_${driveName}`);
    let accessToken = storageGetItem(localStorage, driverTitle);

    if (accessToken) {
      return true;
    } else {
      return false;
    }
  }
}
